import { render } from "./TrendBarChart.vue?vue&type=template&id=37edc830"
import script from "./TrendBarChart.vue?vue&type=script&lang=js"
export * from "./TrendBarChart.vue?vue&type=script&lang=js"

import "./TrendBarChart.vue?vue&type=style&index=0&id=37edc830&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__